import { isApprovedUrl, Modal } from '@bob/library'
import { trackLink } from '@websrc/App/Helpers/adobeTracking'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { useContext, useEffect, useRef, useState } from 'react'

import { AppProviderContext } from '../AppContext'
import { matomo } from '../Tracking/Matomo'
import * as SC from './XLink.style'

export const XLink = () => {
  const t = useStaticText()

  const [href, setHref] = useState<string>()
  const backRef = useRef<HTMLAnchorElement>(null)
  const { matomoPageTemplate, locale } = useContext(AppProviderContext)
  useEffect(() => {
    const clickHandler = (event: any) => {
      let hrefTarget = event.target

      while (hrefTarget && hrefTarget.tagName !== 'A') {
        hrefTarget = hrefTarget.parentElement
      }

      if (
        hrefTarget?.tagName !== 'A' ||
        hrefTarget.getAttribute('data-modal-id') ||
        hrefTarget.hasAttribute('data-ignore-popup')
      ) {
        return
      } else if (hrefTarget.classList.contains('csWidgetBuynow1Prod')) {
        matomo.trackEvent(
          'engagement',
          matomoPageTemplate,
          [`Where To Buy popup`],
          [
            'Buy Now',
            `${hrefTarget.getAttribute('aria-label')}`,
            `href: ${hrefTarget.getAttribute('href')}`,
            `Product number: ${hrefTarget
              .closest('.csWidgetBuyNow1Prod')
              .getAttribute('data-productid')}`,
            `ChannelSight asset id: ${hrefTarget
              .closest('.csWidgetBuyNow1Prod')
              .getAttribute('data-widgetversion')}`,
            `Locale: ${locale}`,
          ],
          'link'
        )

        return
      }

      const hrefHandler = hrefTarget.getAttribute('href')

      // Allow non-href stuff + relative hrefs to go through
      const isApproved = isApprovedUrl(hrefHandler)

      if (!isApproved) {
        // Don't follow the link
        event.preventDefault()
        setHref(hrefHandler)
        trackLink({ name: hrefHandler }, 'e')
      }
    }

    document.addEventListener('click', clickHandler, true)

    return () => {
      document.removeEventListener('click', clickHandler, true)
    }
  }, [locale, matomoPageTemplate])

  const openUrl = () => {
    window.open(href, '_blank', 'noopener noreferrer')
    setHref(undefined)
  }

  return (
    <>
      {href && (
        <Modal
          closeCallback={() => {
            backRef.current?.focus()
            setHref(undefined)
          }}
          position={'center'}
        >
          <SC.Title>{t.external_link.notice_title}</SC.Title>
          <p>{t.external_link.notice_text}</p>
          <SC.OpenWrapper>
            <SC.OpenURL href={href} onClick={openUrl}>
              {t.external_link.continue}
            </SC.OpenURL>
          </SC.OpenWrapper>
        </Modal>
      )}
    </>
  )
}
